import React, { Component, useEffect } from "react";
import { Link } from "react-router-dom";
import MetaTags from 'react-meta-tags';

import { Header, TitleBanner, Category, SectionCareer, Button } from "../../components";

import style from "./Clients.module.scss";
import pattern from "../../assets/patterns/pattern04.svg";
import { useDispatch, useSelector} from 'react-redux';
import useLocale from "../../hooks/useLocale";
import { loadClientsData } from "../../store/slices/clients";
import { normalizeMedia, mapSeo } from "../../api/strapi";

const ALL_CATEGORY_ID = 10010

function HookWrapper({
  render
}) {
  const locale = useLocale();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadClientsData(locale));
  }, [dispatch, locale]);

  return render(loadCategory(locale), loadClients(), loadGlossary(), loadSeo(), locale);
}

function loadGlossary() {
  const { data } = useSelector(state => state.global)
  return (data && data.glossary) || {}
}

function loadCategory(locale) {
  const { data } = useSelector(state => state.clients)
  const items = (data && data.items) || []
  const All = locale === 'id' ? 'Semua' : 'All'

  const seen = new Map()
  items.forEach(el => {
    if (el.category && !seen.has(el.category.id)) {
      seen.set(el.category.id, el.category.title)
    }
  })

  return [{ id: ALL_CATEGORY_ID, category: All }, ...Array.from(seen, ([id, title]) => ({ id, category: title }))]
}

function loadClients() {
  const { data } = useSelector(state => state.clients)
  const items = (data && data.items) || []

  const forAll = items.map(el => ({
    id: el.id,
    categoryId: ALL_CATEGORY_ID,
    categoryId2: el.category && el.category.id,
    client_logo: (normalizeMedia(el.logo) || {}).file_url,
  }))
  const perCategory = items.map(el => ({
    id: el.id,
    categoryId: el.category && el.category.id,
    categoryId2: el.category && el.category.id,
    client_logo: (normalizeMedia(el.logo) || {}).file_url,
  }))
  return [...forAll, ...perCategory]
}

function loadSeo() {
  const { data } = useSelector(state => state.clients)
  return mapSeo(data && data.page && data.page.seo)
}

class Clients extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeCategory: 0,
    }
  }

  _renderClientCard = (el) => {
		if (el.categoryId === this.state.activeCategory){
			return (
				<div className={style.client__link} key={el.id}>
					<div className={style.client__card}>
						<img src={el.client_logo} className={style.client__logo} />
						<div className={style.client__overlay} />
					</div>
				</div>
			)
		}

  }
  printData(data) {
    // console.log("active data", data)
    return data
  }

  _setActive = (data) => {
    this.setState({
      activeCategory: data,
    })
  }
  currentCategory = (categoryData) => {
      if(this.state.activeCategory === 0) {
        if(categoryData.length > 0) {
          let category = categoryData[0]
          this.setState({
            activeCategory: category.id,
          })
          return category.id
        }else{
          return 1
        }
      }else{
        return this.state.activeCategory
      }
  }

  render() {
    return (
      <HookWrapper render={ (categoryData, clientsData, glossary, seo, locale) =>
      <>
        <MetaTags>
          <title>{seo.title}</title>
          <meta name="description" content={seo.meta_description} />
          <meta name="keyword" content={seo.meta_keyword} />
          <meta property="og:title" content={seo.title} />
        </MetaTags>
        <Header />
        <TitleBanner title={glossary.clients || 'Our Clients'} pattern={pattern} backgroundSize={70} />
        <div className={style.client__content}>
          <div className={style.client__inner}>
            <Category category={categoryData} active={this.currentCategory(categoryData)}  onClick={this._setActive} />
            <div className={style.client__list}>
              {clientsData.map(_el => (
                <>{this._renderClientCard(_el)}</>
              ))}
            </div>
            {
							/*
							<div className={style.button__panel}>
              	<Button buttonName="Load More" full />
            	</div>
							*/
						}
          </div>
        </div>
        <SectionCareer locale={locale}/>
      </>
      }/>
    )
  }
}

export default Clients;
